'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1App2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    app: state.moduleData.data.module1.app2,
    allModule: state.moduleData.data.module1
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1App2, _Component);

  function Module1App2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1App2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1App2.__proto__ || (0, _getPrototypeOf2.default)(Module1App2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 7,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'The 2015 Nutrition Australia Healthy Eating Pyramid'
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 1, 2, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module1App2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var pyramidImg = require('../Assets/pyramid.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Healthy eating pyramid'
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            this.state.title
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 5 },
            _react2.default.createElement(
              'p',
              null,
              'The Healthy Eating Pyramid is a simple guide about the types and amounts of foods that children should be eating every day for good health.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Healthy Eating Pyramid informs us to:'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Enjoy a ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'variety'
                  ),
                  ' of foods from the  five food groups'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Choose mostly ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'plant-based '
                  ),
                  'foods (vegetables, fruits and wholegrains)'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'Limit'
                  ),
                  ' saturated',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    ' fat, sugar and salt'
                  ),
                  ' intake'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Choose ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'water'
                  ),
                  ' as your main drink'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'What the Healthy Eating Pyramid tells us'
            ),
            _react2.default.createElement(
              'strong',
              { className: styles.greenText },
              'Vegetables, Legumes & Fruits'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Vegetables, legumes and fruits are on the bottom layer of the pyramid because this is what your child should eat the most of. This also includes frozen varieties as well as fresh vegies and fruits. Tinned legumes as well.'
            ),
            _react2.default.createElement(
              'strong',
              { className: styles.greenText },
              'Grains'
            ),
            _react2.default.createElement(
              'p',
              null,
              'These occupy the next biggest layer of the pyramid. Choose wholemeal or wholegrain breads and cereals, and wholegrain foods such as brown, oats and quinoa instead of white bread, white rice or white pasta.'
            ),
            _react2.default.createElement(
              'strong',
              { className: styles.greenText },
              'Milk, Yoghurt, Cheese & Alternatives'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Alternatives include non-dairy options like soy, rice or cereal milks. If you choose non-dairy milk, make sure it has added calcium. If you can, choose options that have reduced fat and are unsweetened.'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 7 },
            _react2.default.createElement(ReactBootstrap.Image, { src: pyramidImg, className: styles.image60 + ' center-block', responsive: true })
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(
              'strong',
              { className: styles.greenText },
              'Lean meat, poultry, fish, eggs, nuts, seeds, legumes'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Eat a variety of foods from this group and choose low fat cuts of meat and poultry.'
            ),
            _react2.default.createElement(
              'strong',
              { className: styles.greenText },
              'Healthy fats'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We need a small amount of healthy fat every day to support heart health and brain function. We can get healthy fats (poly- and monounsaturated fats) by eating avocado, nuts (e.g. walnuts), seeds (e.g. sunflower seeds) and oily fish (e.g. salmon). When buying oils or spread, choose varieties made from extra virgin olive oil, nuts or seeds.'
            ),
            _react2.default.createElement(
              'strong',
              { className: styles.greenText },
              'Enjoy herbs & spices'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Herbs and spices have many health benefits and add flavour without the need to add salt.'
            ),
            _react2.default.createElement(
              'strong',
              { className: styles.greenText },
              'Limit salt and added sugar'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Avoid adding salt to food when cooking and eating. When reading food labels, choose foods that have < 120mg of sodium in 100g of the food. Check under the column headed 100g on the food label.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Most fresh fruits, vegies, legumes and unsweetened dairy foods contain natural sugars, which are not harmful. When you buy packaged foods, check to see if sugar has been added. We will talk more about reading food labels a little later on.'
            ),
            _react2.default.createElement('div', { className: styles.spacer20 }),
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
            _react2.default.createElement('div', { className: styles.spacer100 })
          )
        )
      );
    }
  }]);
  return Module1App2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module1App2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/App/App2.js
// module id = 1165
// module chunks = 0